import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as constants from '../constants';

import NotificationGeneralComponent from './notification-general-component';
import NotificationUrgentComponent from './notification-urgent-component';

class NotificationTemplateComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { notification, booking, ratingFormSubmit } = this.props;
    if (!notification) {
      return (<div>Loading...</div>)
    }
    let notificationLevel = constants.getLevelForType(notification.notificationType);

    if (notificationLevel === constants.LEVEL_URGENT)
      return (<NotificationUrgentComponent notification={notification} booking={booking} />);

    return (
      <NotificationGeneralComponent notification={notification} booking={booking} ratingFormSubmit={ratingFormSubmit} />
    )
  }
}

export default connect()(NotificationTemplateComponent);
